const SliderChevronLeft = ({ ...props }) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.75} cx={12} cy={12} r={12} fill="#fff" />
      <path
        d="m13.982 16.109.127-.127a.216.216 0 0 0 0-.305l-3.506-3.504 3.506-3.506a.216.216 0 0 0 0-.304l-.127-.128a.215.215 0 0 0-.305 0L9.89 12.02a.215.215 0 0 0 0 .305l3.786 3.783c.084.086.22.086.305.002Z"
        fill="#646464"
      />
    </svg>
  )
}

export default SliderChevronLeft
